var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-4",attrs:{"fluid":""}},[_c('h3',{staticClass:"mb-4"},[_vm._v("ایجاد تخفیف")]),_c('form-offer',{attrs:{"submit":_vm.createOffer,"form":_vm.offer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }